var Handlebars = require("../../../../../node_modules/.pnpm/handlebars@4.7.10/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"summary-vehicle-repairable-brand-table\" class=\"summary-charts summary-charts-2\"></div>\n<button id=\"summary-vehicle-repairable-brand-evoluation-button\" class=\"summary-button\" style=\"margin-top: -60px; border-top-left-radius: 0; border-top-right-radius: 0; \">\n    "
    + container.escapeExpression(__default(require("./i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"Action.ShowRankingTable",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":3,"column":38}}}))
    + "\n</button>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/scripts/core/templates/templates/summary-vehicle-repairable-brand-after-sales.hbs
// module id = ll0k
// module chunks = 1